export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResearchDirectory.vue?vue&type=template&id=46ef33e4"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ResearchDirectory.vue?vue&type=template&id=46ef33e4
// module id = 407
// module chunks = 0